module.exports = __webpack_public_path__ + "static/media/16UNODC40.dc36c5cc.jpg";